import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
import '../features/doc-generation/events';
export default defineGlobalLayer({
  id: 'document-generation',
  component: lazy(() => import('../features/doc-generation/GenerationLayer')),
});
